export interface CategoryItem {
  slug: string;
  name: string;
  desc: string;
  icon: string;
}

export interface VideoItem {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  duration: string;
  views: string;
  author: string;
  date: string;
  hot?: boolean;
  tag: string;
  tags: string[];
  summary: string;
  content: string[];
}

export const categories: CategoryItem[] = [
  { slug: "gossip", name: "娱乐八卦", desc: "圈内速递、幕后爆料，最新吃瓜一手资讯", icon: "ri-chat-smile-3-line" },
  { slug: "star", name: "明星动态", desc: "明星行程、红毯造型与最新动态追踪", icon: "ri-star-smile-line" },
  { slug: "variety", name: "综艺片段", desc: "热门综艺高光时刻与名场面合集", icon: "ri-tv-2-line" },
  { slug: "film", name: "影视花絮", desc: "片场揭秘、拍摄花絮与幕后故事", icon: "ri-clapperboard-line" },
  { slug: "influencer", name: "红人视频", desc: "网络红人、博主们的精彩日常视频", icon: "ri-camera-lens-line" },
];

export const hotTopics: string[] = [
  "顶流演唱会后台花絮",
  "新综艺阵容官宣",
  "老戏骨回归荧幕",
  "红毯造型大盘点",
  "千万粉红人翻包",
  "爆破戏幕后揭秘",
  "美食综艺名场面",
  "机场穿搭再登热搜",
];

export const videos: VideoItem[] = [
  {
    slug: "dao-yan-shen-ye-dui-xi",
    title: "新剧开机现场：导演深夜与新人演员对戏，现场氛围意外温馨",
    category: "gossip",
    categoryName: "娱乐八卦",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20set%20at%20night%20with%20warm%20practical%20lights%2C%20director%20and%20actor%20reading%20script%20together%20by%20lamp%20glow%2C%20editorial%20behind%20the%20scenes%20photography%2C%20soft%20golden%20tones%2C%20intimate%20working%20atmosphere&width=800&height=450&seq=cg-card-01&orientation=landscape",
    duration: "03:42",
    views: "128万",
    author: "圈内观察员",
    date: "2026-08-18",
    hot: true,
    tag: "独家",
    tags: ["新剧开机", "幕后", "圈内速递"],
    summary: "某都市情感剧开机首夜，有现场工作人员拍到导演与新人演员深夜对戏的画面，两人围着台灯逐句打磨台词，认真又专注的状态引发网友点赞。",
    content: [
      "近日，某部都市情感剧低调开机，开机首夜现场便传出一段颇有意思的画面：收工后，导演并没有急着回酒店，而是拉着一位新人演员在片场角落的棚灯下逐句对戏。",
      "据现场工作人员透露，两人从晚上九点半一直聊到接近凌晨，期间导演不断调整台词的停顿与情绪，新人演员也一遍遍重来，完全没有赶时间的敷衍感。",
      "这一幕被工作人员随手拍下并传到网上，很快引发热议。不少网友感叹，如今流量当道，能遇到愿意陪新人磨戏的导演实属难得，也有人评价这位新人态度端正，未来可期。",
      "截至目前，片方并未就此事公开回应，但业内人士普遍认为，这样脚踏实地的剧组氛围，反而让人对这部戏的成片多了几分期待。",
    ],
  },
  {
    slug: "ding-liu-hou-tai-hua-xu",
    title: "顶流演唱会后台真实花絮曝光，细节让粉丝直呼被圈粉",
    category: "star",
    categoryName: "明星动态",
    cover: "https://readdy.ai/api/search-image?query=backstage%20of%20a%20huge%20concert%20with%20warm%20stage%20lights%20glowing%20golden%2C%20musician%20preparing%20backstage%20near%20curtain%2C%20cinematic%20editorial%20photography%2C%20candid%20moment%2C%20warm%20ambient%20tone&width=800&height=450&seq=cg-card-02&orientation=landscape",
    duration: "05:18",
    views: "356万",
    author: "红毯小分队",
    date: "2026-08-17",
    hot: true,
    tag: "热点",
    tags: ["演唱会", "后台", "明星动态"],
    summary: "某顶流歌手巡演后台片段流出，上妆间隙不忘给伴舞递水、提醒团队补充能量，低调又贴心的细节让不少路人也忍不住转粉。",
    content: [
      "上周末，某顶流歌手在一线城市连开两场巡演，上座率爆满。而演出结束后，一段后台花絮悄悄刷屏，内容却与舞台上的高光毫不相关。",
      "视频中，这位歌手在上妆间隙反复确认伴舞团队的状态，主动为工作人员递水，还特意叮嘱助手在换装间隙给乐手留出补充能量的时间。",
      "这些看似不起眼的细节被镜头如实记录下来，传到社交平台后迅速引发讨论。不少粉丝表示，追了这么多年，最打动人的从来都是这些毫无表演痕迹的善意。",
      "业内人士评论称，能让整个团队心甘情愿跟着熬夜排练，靠的往往不是名气，而是这份将心比心的尊重。",
    ],
  },
  {
    slug: "zong-yi-zheng-gui",
    title: "综艺录制现场嘉宾暗中较劲，名场面被完整记录",
    category: "variety",
    categoryName: "综艺片段",
    cover: "https://readdy.ai/api/search-image?query=colorful%20variety%20show%20studio%20stage%20with%20bright%20set%20lights%2C%20contestants%20in%20casual%20outfits%20competing%20playfully%2C%20lively%20studio%20atmosphere%2C%20cinematic%20tv%20production%20photography%2C%20warm%20vibrant%20tones&width=800&height=450&seq=cg-card-03&orientation=landscape",
    duration: "04:55",
    views: "203万",
    author: "综艺观察室",
    date: "2026-08-16",
    tag: "名场面",
    tags: ["真人秀", "竞技", "综艺片段"],
    summary: "最新一期户外竞技综艺中，两位常驻嘉宾为了一个游戏环节暗自较劲，你来我往的名场面被镜头完整记录，现场笑声不断。",
    content: [
      "最新一期户外竞技真人秀播出后，一个游戏环节迅速冲上热搜。起因很简单：两位常驻嘉宾为了争夺一个并不重要的‘加分道具’，从开始就互相较劲。",
      "只见两人一边嘴上互相调侃，一边在动作上寸步不让，你夺我抢之间还夹杂着各种即兴的金句，把现场导演都逗得连连笑场。",
      "更难得的是，这种较劲始终保持在综艺该有的分寸之内，既不伤人面子，又把节目效果拉满。网友直言，这才是大家想看的‘有效综艺’。",
      "节目组随后也在官微放出该环节的加长版剪辑，播放量短时间内突破百万，足以看出观众对这类真实互动的偏爱。",
    ],
  },
  {
    slug: "shi-li-pai-ju-zhen-rong",
    title: "实力派女演员官宣新电影阵容，搭档阵容被赞神仙配置",
    category: "star",
    categoryName: "明星动态",
    cover: "https://readdy.ai/api/search-image?query=elegant%20cinema%20film%20poster%20mood%20with%20warm%20theatrical%20lighting%2C%20stylish%20actress%20silhouette%20in%20front%20of%20soft%20golden%20backdrop%2C%20editorial%20movie%20promotion%20photography%2C%20sophisticated%20tone&width=800&height=450&seq=cg-card-04&orientation=landscape",
    duration: "02:10",
    views: "98万",
    author: "影讯速递",
    date: "2026-08-15",
    hot: true,
    tag: "官宣",
    tags: ["电影", "阵容官宣", "明星动态"],
    summary: "实力派女演员新片阵容正式官宣，男主角与导演均获业内认可，被网友评价为‘神仙配置’，观众期待值拉满。",
    content: [
      "今日中午，一部备受期待的文艺题材电影正式官宣主创阵容，实力派女演员确认领衔出演，同时公开的男主角与导演人选同样来头不小。",
      "消息一出，社交平台瞬间热闹起来。不少影迷表示，这个组合无论从演技厚度还是选片品味来看都堪称‘神仙配置’，光是看名字就值得买票。",
      "据悉，该片改编自一部获奖短篇小说，讲述普通人在时代变迁中的坚守与成长。导演在采访中透露，为了找到契合角色的演员，团队前后接触了数十位人选。",
      "目前影片已进入筹备阶段，预计明年春季开机。片方表示，更多幕后阵容将在后续逐步揭晓。",
    ],
  },
  {
    slug: "ji-chang-chuan-da",
    title: "顶流男星机场穿搭再度登上热搜，简约风格却成带货爆款",
    category: "star",
    categoryName: "明星动态",
    cover: "https://readdy.ai/api/search-image?query=stylish%20young%20man%20in%20minimal%20casual%20streetwear%20walking%20through%20sunlit%20modern%20airport%2C%20fashion%20editorial%20photography%2C%20warm%20natural%20light%2C%20clean%20background&width=800&height=450&seq=cg-card-05&orientation=landscape",
    duration: "01:35",
    views: "276万",
    author: "穿搭研究所",
    date: "2026-08-14",
    tag: "热搜",
    tags: ["机场穿搭", "时尚", "明星动态"],
    summary: "顶流男星最新机场穿搭再度登上热搜，看似简单的黑白基础款，却在数小时内带火了同款单品，时尚博主纷纷拆解。",
    content: [
      "又双叒叕是机场！顶流男星昨日的返程穿搭再度登上热搜榜。与以往华丽造型不同，这次他只穿了一件白T搭配黑色工装外套，脚踩一双基础款运动鞋。",
      "就是这么一身看似‘随手一穿’的搭配，却在数小时内带动同款单品搜索量暴涨。多位时尚博主连夜出视频拆解：版型、面料、比例，每一样都被讲得头头是道。",
      "有从业者分析，如今明星穿搭早已不是简单的‘好看’二字，而是背后团队对镜头语言和社交传播的精准把握。越是简单的单品，越考验审美功力。",
      "随着讨论发酵，相关话题阅读量已突破千万。不少网友调侃：看完只能说，好看的人披个麻袋都好看，但这句话背后，其实是严格的衣品管理。",
    ],
  },
  {
    slug: "lao-xi-gu-hui-gui",
    title: "老戏骨时隔八年回归荧幕，观众集体期待：这才是真正的演技",
    category: "star",
    categoryName: "明星动态",
    cover: "https://readdy.ai/api/search-image?query=dignified%20seasoned%20actor%20in%20dark%20coat%20standing%20in%20warm%20golden%20light%20on%20film%20set%2C%20cinematic%20editorial%20portrait%2C%20deep%20warm%20tones%2C%20respected%20artistic%20mood&width=800&height=450&seq=cg-card-06&orientation=landscape",
    duration: "02:48",
    views: "412万",
    author: "荧幕观察",
    date: "2026-08-13",
    hot: true,
    tag: "回归",
    tags: ["老戏骨", "复出", "明星动态"],
    summary: "阔别荧幕八年的老戏骨宣布出演一部年代剧，消息一出观众集体沸腾，直呼这才是真正值得期待的演技回归。",
    content: [
      "今天上午，一部年代大戏官宣了主演名单，阔别荧幕整整八年的老戏骨赫然在列，消息一出迅速登顶热搜。",
      "这位老艺术家曾以多部经典角色深入人心，八年前宣布暂别荧幕后，便专心投入舞台剧与教学工作，极少在镜头前露面。",
      "此次回归，他将在剧中饰演一位历经时代变迁的基层干部。片方透露，为了塑造好角色，老人提前数月深入生活采风，光是笔记就写满了厚厚一本。",
      "消息传开后，网友在评论区集体刷屏‘真正的演技回来了’。业内人士也表示，他的加盟无疑为这部年代剧的成色上了双保险。",
    ],
  },
  {
    slug: "zheng-gui-dao-yan",
    title: "户外真人秀名场面：全员合谋整蛊导演，结局反转笑翻全场",
    category: "variety",
    categoryName: "综艺片段",
    cover: "https://readdy.ai/api/search-image?query=group%20of%20friends%20laughing%20during%20outdoor%20reality%20show%20at%20golden%20sunset%20field%2C%20playful%20prank%20moment%2C%20cinematic%20editorial%20photography%2C%20warm%20glowing%20natural%20light%2C%20candid%20joyful&width=800&height=450&seq=cg-card-07&orientation=landscape",
    duration: "06:30",
    views: "189万",
    author: "综艺观察室",
    date: "2026-08-12",
    tag: "名场面",
    tags: ["真人秀", "整蛊", "综艺片段"],
    summary: "最新一期户外真人秀中，常驻嘉宾全员合谋整蛊导演，计划进行到一半却迎来神反转，结局直接笑翻全场观众。",
    content: [
      "看惯了嘉宾被节目组‘折磨’，最新一期户外真人秀上演了一出反转大戏：常驻嘉宾们竟然联合起来，密谋整蛊自己的导演。",
      "节目中，几位嘉宾假装对环节流程不满，故意在镜头前闹脾气、摆烂，导演起初还一本正经地想办法安抚，表情管理逐渐破功。",
      "就在观众以为嘉宾真要‘罢工’时，镜头一转——原来这一切都是提前设计好的惊喜，真正的整蛊对象正是全程被蒙在鼓里的导演。",
      "节目播出后，这段‘反客为主’的名场面迅速走红。网友纷纷留言：这才是真人秀该有的化学反应，比刻意设计的笑点高级多了。",
    ],
  },
  {
    slug: "ji-xing-wu-dao",
    title: "综艺舞台即兴舞蹈点燃全场，网友：这一段我能看十遍",
    category: "variety",
    categoryName: "综艺片段",
    cover: "https://readdy.ai/api/search-image?query=energetic%20dancer%20mid%20move%20on%20bright%20stage%20with%20warm%20spotlights%20and%20dynamic%20lighting%2C%20cinematic%20performance%20photography%2C%20vibrant%20motion%20blur%2C%20passionate%20energy&width=800&height=450&seq=cg-card-08&orientation=landscape",
    duration: "03:22",
    views: "334万",
    author: "舞台剪辑师",
    date: "2026-08-11",
    hot: true,
    tag: "高能",
    tags: ["舞蹈", "舞台", "综艺片段"],
    summary: "一位嘉宾在综艺舞台上临时起意的即兴舞蹈片段意外出圈，动作流畅、节奏感爆棚，网友直呼‘这段我能看十遍’。",
    content: [
      "在最近一期音乐综艺的候场间隙，一位嘉宾被现场音乐带动，临时起意来了一段即兴舞蹈。没有彩排、没有走位，全靠音乐与身体的本能反应。",
      "没想到，这段短短几十秒的即兴表演意外成为全场焦点。动作干净利落，卡点精准，连现场的专业舞者都忍不住鼓掌叫好。",
      "片段被单独剪出后迅速在网络上疯传，播放量一路飙升。网友在评论区花式刷屏：‘这才是真·天选舞台人’‘建议把这段单独出个直拍’。",
      "有媒体评价，这种不设防的真实状态，恰恰是综艺最难得的魅力所在——当人放下防备，感染力反而会加倍放大。",
    ],
  },
  {
    slug: "mei-shi-la-dao-ku",
    title: "美食综艺现场：嘉宾被辣到当场流泪，画面既好笑又真实",
    category: "variety",
    categoryName: "综艺片段",
    cover: "https://readdy.ai/api/search-image?query=steaming%20spicy%20red%20hotpot%20and%20chili%20dishes%20on%20a%20warm%20wooden%20table%2C%20food%20show%20studio%2C%20cinematic%20editorial%20food%20photography%2C%20appetizing%20warm%20tones%2C%20tempting%20texture&width=800&height=450&seq=cg-card-09&orientation=landscape",
    duration: "04:08",
    views: "156万",
    author: "吃货现场",
    date: "2026-08-10",
    tag: "下饭",
    tags: ["美食", "挑战", "综艺片段"],
    summary: "一档美食综艺设下‘特辣挑战’环节，嘉宾硬着头皮入口后当场被辣到流泪，画面既好笑又真实，被网友称为‘年度下饭名场面’。",
    content: [
      "在最新一期美食综艺中，节目组设置了一个‘特辣挑战’环节，端上桌的红油锅底和整盘小米辣让在场嘉宾的脸色集体变了又变。",
      "面对镜头，一位自称‘很能吃辣’的嘉宾率先打头阵，结果刚入口没几秒就被辣到满脸通红、当场飙泪，连话都说不利索，引得全场爆笑。",
      "搞笑之余，节目组还贴心地准备了冰镇饮料和酸奶救场，并贴出温馨提醒：辣度挑战量力而行，切勿模仿。这份人性化的处理也赢得观众好感。",
      "不少网友在弹幕里留言：这才是真实的下饭综艺，一边被辣到流泪，一边看得人直流口水，已经默默下单了同款火锅底料。",
    ],
  },
  {
    slug: "bao-po-xi-mu-hou",
    title: "大片片场花絮：爆破戏背后的惊险时刻，安全员全程紧盯",
    category: "film",
    categoryName: "影视花絮",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20explosion%20scene%20on%20action%20film%20set%20with%20dust%20and%20warm%20firelight%20at%20dusk%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20intense%20atmosphere%2C%20stunt%20coordinator%20in%20frame&width=800&height=450&seq=cg-card-10&orientation=landscape",
    duration: "07:12",
    views: "287万",
    author: "片场直击",
    date: "2026-08-09",
    hot: true,
    tag: "独家",
    tags: ["片场", "爆破戏", "影视花絮"],
    summary: "一部动作大片公开爆破戏拍摄花絮，爆破师与安全员反复检查的紧张过程被完整记录，惊险画面背后是严谨到苛刻的安保流程。",
    content: [
      "动作大片最让人肾上腺素飙升的，莫过于火光冲天的爆破戏。最近，一部即将上映的动作片放出一段爆破戏幕后花絮，揭开了一场惊险拍摄背后的严苛流程。",
      "画面中，爆破师在正式开拍前进行了多轮安全检查，从爆破点位的距离到人群疏散路线，每一项都反复核对。安全员则全程紧盯，确保万无一失。",
      "随着导演一声令下，爆炸瞬间腾起巨大的火光与烟尘，主演在安全范围内按要求完成动作，随后迅速撤离，整个过程一气呵成。",
      "花絮发出后，不少影迷在评论区致敬幕后团队：银幕上的每一秒惊险，背后都是成百上千次的演练与坚守。这种敬畏之心，值得被看见。",
    ],
  },
  {
    slug: "wei-ya-xi-yi-tian",
    title: "剧组日常：一场威亚戏吊了整整一天，演员下来时手臂全是淤青",
    category: "film",
    categoryName: "影视花絮",
    cover: "https://readdy.ai/api/search-image?query=wires%20and%20stunt%20rigging%20on%20a%20film%20set%20with%20warm%20afternoon%20light%2C%20crew%20members%20adjusting%20safety%20wires%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20dedicated%20production%20mood&width=800&height=450&seq=cg-card-11&orientation=landscape",
    duration: "05:47",
    views: "142万",
    author: "片场直击",
    date: "2026-08-08",
    tag: "幕后",
    tags: ["威亚", "古装", "影视花絮"],
    summary: "一部古装剧曝光威亚戏拍摄日常，演员为了一个高空动作吊在钢索上反复尝试一整天，下地时手臂满是淤青，敬业程度令人动容。",
    content: [
      "在古装剧里，飞檐走壁的轻功戏总是又飒又美，但很少有人知道，这些看似行云流水的镜头，往往要用一整天甚至更久去打磨。",
      "最近，一部古装剧晒出一组威亚戏幕后照：演员为了一个高空转身加落地的动作，被钢索吊在空中反复尝试了一整天。",
      "照片里，演员的掌心被勒出明显的红痕，手臂上也留下了几处淤青，但面对镜头依然笑着说‘再来一条没问题’。这种状态让现场工作人员既心疼又敬佩。",
      "剧组随后发文感谢演员的付出，并强调所有高危动作都在专业团队保护下进行。网友看后纷纷感慨：真正的好戏，从来都是拿汗水一点点磨出来的。",
    ],
  },
  {
    slug: "sha-qing-yan-mu-hou",
    title: "影视杀青宴幕后温情瞬间：主创相拥告别，现场感动落泪",
    category: "film",
    categoryName: "影视花絮",
    cover: "https://readdy.ai/api/search-image?query=warm%20dinner%20gathering%20of%20film%20crew%20celebrating%20wrap%20with%20toasts%20and%20soft%20candles%2C%20emotional%20farewell%20moment%2C%20cinematic%20editorial%20photography%2C%20cozy%20golden%20ambience&width=800&height=450&seq=cg-card-12&orientation=landscape",
    duration: "03:55",
    views: "89万",
    author: "片场直击",
    date: "2026-08-07",
    tag: "温情",
    tags: ["杀青", "剧组", "影视花絮"],
    summary: "一部都市剧杀青宴现场温情满满，主创团队举杯相拥、依依惜别，有人当场落泪，幕后花絮让观众感受到剧组深厚的情谊。",
    content: [
      "历时三个多月的紧张拍摄后，一部都市剧迎来正式杀青。杀青宴上，没有华丽的排场，却充满了让人眼眶发热的温情瞬间。",
      "主创团队围坐一桌，举杯敬过每一个熬过大夜的部门。从导演到场工，从主演到群演，每个人都轮流起身致谢，现场气氛一度催泪。",
      "最令人动容的，是几位合作多部戏的主创在告别时紧紧相拥，有人当场红了眼眶。镜头记录下的这一幕，比任何宣传语都更有分量。",
      "宴后，剧组官微晒出这段幕后视频并配文：‘戏会散场，但并肩奋斗的日子不会忘记。’不少网友被这份真诚打动，直言越来越期待这部戏的上线。",
    ],
  },
  {
    slug: "qian-wan-fen-hong-tiao-zhan",
    title: "千万粉丝红人挑战24小时不玩手机，结果却意外翻车",
    category: "influencer",
    categoryName: "红人视频",
    cover: "https://readdy.ai/api/search-image?query=person%20putting%20smartphone%20away%20at%20a%20cozy%20warm%20desk%20by%20window%2C%20lifestyle%20challenge%20vlog%20photography%2C%20soft%20natural%20morning%20light%2C%20minimal%20warm%20aesthetic&width=800&height=450&seq=cg-card-13&orientation=landscape",
    duration: "08:24",
    views: "512万",
    author: "红人观察室",
    date: "2026-08-06",
    hot: true,
    tag: "爆款",
    tags: ["挑战", "vlog", "红人视频"],
    summary: "一位千万粉丝红人发起‘24小时不玩手机’挑战，结果刚开始没几小时就因习惯性摸手机而当场破功，搞笑又真实的画面获赞无数。",
    content: [
      "在数字时代，离开手机24小时到底有多难？一位拥有千万粉丝的旅行博主，最近就在镜头前发起了一场‘24小时不玩手机’的硬核挑战。",
      "挑战刚开始还算顺利，博主用读书、做饭、整理房间来打发时间，画面一度岁月静好。可就在大家以为他要成功时，一场‘真香’现场出现了。",
      "当天傍晚，博主在切水果时下意识地伸手去够桌上的手机，等反应过来自己正在录挑战视频时，才尴尬地笑着直呼‘习惯了，真的习惯了’。",
      "这段既真实又搞笑的‘翻车’画面意外成为整支视频的高潮，评论区瞬间被‘这不就是我吗’刷屏。博主也坦言，这次挑战让他深刻意识到，自己比想象中更依赖手机。",
    ],
  },
  {
    slug: "mei-zhuang-fan-bao",
    title: "美妆博主翻包记引热议：网友直呼被种草，又担心钱包不保",
    category: "influencer",
    categoryName: "红人视频",
    cover: "https://readdy.ai/api/search-image?query=top%20view%20of%20makeup%20products%20and%20cosmetic%20bag%20flat%20lay%20on%20warm%20cream%20background%2C%20beauty%20vlog%20photography%2C%20soft%20golden%20light%2C%20elegant%20minimal%20composition&width=800&height=450&seq=cg-card-14&orientation=landscape",
    duration: "05:06",
    views: "221万",
    author: "美妆笔记",
    date: "2026-08-05",
    tag: "种草",
    tags: ["美妆", "翻包", "红人视频"],
    summary: "人气美妆博主晒出随身化妆包翻包记，从平价好物到大牌单品一应俱全，细致讲解让网友纷纷喊话‘钱包又保不住了’。",
    content: [
      "美妆圈向来少不了‘翻包’这一经典环节。最近，一位人气美妆博主发布了一支随身化妆包翻包记，短短一天播放量便突破两百万。",
      "视频中，她如数家珍地展示包里的每一件单品，从百元内的平价口红到重磅遮瑕，再到补妆必备的定妆喷雾，件件都附上详细的使用心得与性价比分析。",
      "最让网友心动的，是她对‘哪些值得回购、哪些踩过雷’的诚实分享，全程没有硬广式的吹捧，反而像极了朋友间的真诚种草。",
      "评论区瞬间被‘已经加进购物车’‘钱包又保不住了’刷屏。博主也在视频结尾提醒大家理性消费、按需入手，这种负责的态度也让她圈粉无数。",
    ],
  },
  {
    slug: "lv-xing-bo-zhu-bian-jiang",
    title: "旅行博主带你探秘边陲小镇，烟火气十足的画面治愈全网",
    category: "influencer",
    categoryName: "红人视频",
    cover: "https://readdy.ai/api/search-image?query=quaint%20border%20town%20street%20at%20sunset%20with%20warm%20lantern%20glow%20and%20local%20market%20stalls%2C%20travel%20vlog%20photography%2C%20cinematic%20warm%20tones%2C%20atmospheric%20candid%20scene&width=800&height=450&seq=cg-card-15&orientation=landscape",
    duration: "10:18",
    views: "468万",
    author: "边走边拍",
    date: "2026-08-04",
    hot: true,
    tag: "治愈",
    tags: ["旅行", "vlog", "红人视频"],
    summary: "知名旅行博主发布边陲小镇探秘vlog，慢镜头下的小巷、市集与晚霞充满烟火气，短短几日播放量便突破四百万，被网友称为‘年度治愈视频’。",
    content: [
      "在快节奏的城市生活里，一条慢下来看世界的视频，往往最能击中人心。近日，一位知名旅行博主发布的边陲小镇探秘vlog，就引发了一场全网‘集体治愈’。",
      "视频没有华丽的转场，只有最朴实的记录：清晨冒着热气的早点摊、午后在巷口晒太阳的老人、傍晚被晚霞染红的旧街。镜头缓慢，却充满温度。",
      "最动人的一幕，是博主与当地一位卖花的老奶奶在镜头前拉家常，老人笑着分享小镇几十年的变迁，那种不设防的亲切感，让无数网友瞬间破防。",
      "发布短短几天，这支视频的播放量已突破四百万。评论区的留言几乎都是‘看哭了’‘想起故乡的小镇’‘治愈了我一整天的疲惫’。或许，这份直抵人心的烟火气，正是我们最渴望的远方。",
    ],
  },
];

export const faqs = [
  {
    q: "吃瓜视频网多久更新一次内容？",
    a: "吃瓜视频网每天多次更新，覆盖娱乐八卦、圈内速递、明星动态、综艺片段、影视花絮与红人视频等热门板块，第一时间为你同步娱乐圈新鲜事。",
  },
  {
    q: "如何快速找到我想看的明星动态或综艺片段？",
    a: "你可以在网站顶部搜索框输入明星姓名、节目名称或关键词，也可以直接进入对应分类栏目，通过分类与标签快速筛选到最想看的内容。",
  },
  {
    q: "吃瓜视频网的内容可以转载或分享吗？",
    a: "欢迎把喜欢的内容分享到朋友圈或社交平台。如需在其他平台或商业渠道进行转载，请先与我们取得联系并获得授权，共同尊重原创劳动成果。",
  },
  {
    q: "发现某些内容不够准确或涉及侵权，该如何反馈？",
    a: "你可以通过网站底部或关于我们页面的联系方式与我们沟通，也可以在相应内容下方留言。我们会第一时间核实处理，并真诚感谢每一位用户的监督。",
  },
  {
    q: "吃瓜视频网会接收用户的爆料投稿吗？",
    a: "会的。我们欢迎真实、有依据的圈内线索与娱乐动态投稿。投稿请通过联系我们页面提交，我们将依据内容价值进行筛选与核实，并保护投稿人的隐私。",
  },
];